import React from "react";
import { useNavigate } from "react-router-dom";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { TableReportes } from "../components/TableReportes";
import { useLocation } from "react-router-dom";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

import "../theme/ReporteCierreDia.css";
import { useDynamicAuth } from "../context/AuthProviderContext"; // Importar el hook

/** Reporte Cierre del dia */
export const ReportePage = () => {
  const navigate = useNavigate();
  const authProvider = useDynamicAuth(); // Usar el hook
  const { state } = useLocation();
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <BtnGoBack caption="Volver a reportes" />
                </div>
              </div>

              <TableReportes />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
